module.exports = __webpack_public_path__ + "0f88577a82a8d9a99be70c08142d4429.png";